/**
 * URLs oficiales del SAT (consulta pública, sin FIEL).
 * La ruta histórica .../aplicacion/operacion/29073/... devuelve 403 desde ~2024.
 */
export const SAT_VALIDADOR_RFC_PORTAL_URL =
  "https://portalsat.plataforma.sat.gob.mx/ConsultaRFC/";

/** Página de trámites RFC en sat.gob.mx (navegación manual si falla el enlace directo). */
export const SAT_TRAMITES_RFC_HOME_URL =
  "https://www.sat.gob.mx/tramites/operacion/29073/validacion-del-rfc";
